module.exports = __webpack_public_path__ + "static/Tugboat Logic-3e1a9609c6299362be4349432a37e1cd.jpg";